// Interface

import util from '@/utils/classToObject'
import { IMissionPlanTemplateState } from './state'
import { AloDbMissionPlanTemplate } from '@/models/alodb/AloDbMissionPlanTemplate'

export class MissionPlanTemplateGetter {  
      
  public missionPlanTemplates(state:IMissionPlanTemplateState,getters:any) {
    return state.missionPlanTemplates
  }

  public missionPlanTemplatesById(state:IMissionPlanTemplateState) {
    return state.missionPlanTemplates.reduce(
      (acc, missionPlanTemplate) => {
        acc[missionPlanTemplate.MPT_ID!] = missionPlanTemplate
        return acc
      },
      {} as { [id: number]: AloDbMissionPlanTemplate }
    )
  }  

  public modifiedAdmMissionPlanTemplate(state:IMissionPlanTemplateState,getters:any) {
    return state.modifiedAdmMissionPlanTemplate
  }

  public originalAdmMissionPlanTemplate(state:IMissionPlanTemplateState,getters:any) {
    return state.originalAdmMissionPlanTemplate
  }

  public missionPlanTemplateLoading(state:IMissionPlanTemplateState,getters:any) {
    return state.missionPlanTemplateLoading
  }

  public missionPlanTemplateStatus(state:IMissionPlanTemplateState) {     
    return state.status
  }

  public adminMissionPlanTemplateFilter(state:IMissionPlanTemplateState) {     
    return state.adminFilter
  }
  
}

export default util.classToObject(MissionPlanTemplateGetter)